import React from 'react'

function SearchResultsItem(props) {
    const post = props.data
    return (
        <div className="post_cont">
            <a href={post.permalink}>
                <span className="post_cont__date">{post.parsed_date}</span>
                <div className="post_cont__thumb_placeholder">
                    <img
                        src={
                            post.image
                                ? post.image
                                : 'https://www.sportsnet.ca/wp-content/themes/sportsnet-nhl/images/sn_default_logo.gif'
                        }
                        alt={post.title}
                    />
                </div>
                <div className="post_cont__details">
                    <span className="post_cont__title">{post.title}</span>
                    <p className="post_cont__excerpt">{post.content}</p>
                    {/* {post.author && (
                        <span className="post_cont__byline">By&nbsp;{post.author}</span>
                    )} */}
                </div>
            </a>
        </div>
    )
}

export default SearchResultsItem
